import { DeviceAspectRatioType } from '@models/enums/device-aspect-ratio-type.enum';
import { Measurements } from './measurements';

export class OtherUserPreferences {
    aspectRatio: keyof typeof DeviceAspectRatioType;
    measurements: Measurements = new Measurements();
}
